function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-120 -5755)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5346)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120 170)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 236)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 15c1.0875 0.018 2.6535-1.3695 3.4395-1.941 6.2205-4.5135 6.6945-4.908 8.1285-6.033 0.273-0.2115 0.432-0.5385 0.432-0.885v-0.891c0-1.242-1.008-2.25-2.25-2.25h-19.5c-1.242 0-2.25 1.008-2.25 2.25v0.891c0 0.3465 0.159 0.6705 0.4305 0.885 1.4355 1.1205 1.908 1.5195 8.1285 6.033 0.7875 0.5715 2.3535 1.959 3.441 1.941m11.546-6.057c0.1815-0.1455 0.4545-9e-3 0.4545 0.2205v9.5865c0 1.242-1.008 2.25-2.25 2.25h-19.5c-1.242 0-2.25-1.008-2.25-2.25v-9.582c0-0.234 0.267-0.3645 0.4545-0.2205 1.05 0.816 2.442 1.8525 7.224 5.3265 0.9885 0.7215 2.658 2.2395 4.3215 2.2305 1.6725 0.0135 3.375-1.5375 4.326-2.2305 4.782-3.474 6.1695-4.515 7.2195-5.331"
}))))));

var SvgMail = function SvgMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail.11c4a7b7.svg";
export { ForwardRef as ReactComponent };